import { render, staticRenderFns } from "./EditFormTabGeneral.vue?vue&type=template&id=ccd3fc70&scoped=true&"
import script from "./EditFormTabGeneral.vue?vue&type=script&lang=js&"
export * from "./EditFormTabGeneral.vue?vue&type=script&lang=js&"
import style0 from "./EditFormTabGeneral.vue?vue&type=style&index=0&id=ccd3fc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd3fc70",
  null
  
)

export default component.exports